import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="card" style={{ textAlign: "center" }}>
        <h1 className="title">Peoflo Admin Panel</h1>
        <p className="subtitle">
          Manage users, businesses, freelancers and platform operations.
        </p>

        <button className="btn" onClick={() => navigate("/login")}>
          Login as Admin
        </button>
      </div>
    </div>
  );
};

export default Home;